export const safeGet = (key, fallback) => {
  try {
    const stored = localStorage.getItem(key)
    return stored !== null ? JSON.parse(stored) : fallback
  } catch {
    return fallback
  }
}

export const safeSet = (key, value) => {
  try {
    localStorage.setItem(key, JSON.stringify(value))
  } catch {}
}

export const safeRemove = (key) => {
  try {
    localStorage.removeItem(key)
  } catch {}
}
